import { Component } from '@angular/core';
import { BaseMortgageApplicationComponent } from '../../../pages/base-mortgage-application.component';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-additional-borrowings-residential',
  templateUrl: './additional-borrowings-residential.component.html',
  styleUrls: ['./additional-borrowings-residential.component.scss']
})
export class AdditionalBorrowingsResidentialComponent extends BaseMortgageApplicationComponent {
  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }
}
